import { Link } from "react-router-dom";

export default function AffiliateDisclosureInline() {
  return (
    <div className="disclosure">
      <strong>Disclosure:</strong> Some links are affiliate links, meaning we may earn a commission
      at no extra cost to you. <Link to="/affiliate-disclosure">Learn more</Link>.
    </div>
  );
}